import React from 'react';
import { CompassIcon, GiftIcon, ScanLineIcon, UserIcon } from 'lucide-react';
type TabKey = 'discover' | 'scan' | 'activity' | 'profile';
const tabs = [{
  key: 'discover',
  icon: CompassIcon,
  label: 'Discover'
}, {
  key: 'scan',
  icon: ScanLineIcon,
  label: 'Scan'
}, {
  key: 'activity',
  icon: GiftIcon,
  label: 'Activity'
}, {
  key: 'profile',
  icon: UserIcon,
  label: 'Profile'
}] as const;
export function TabBar({
  active
}: {
  active: TabKey;
}) {
  return <div className="absolute inset-x-0 bottom-0 z-20 flex justify-around border-t border-line bg-white px-3 pb-4 pt-2" data-id="element-174" data-mp="udm43oxmj46f">
      {tabs.map(({
      key,
      icon: Icon,
      label
    }) => <span key={key} className={`flex flex-col items-center gap-0.5 text-[8.5px] font-semibold ${active === key ? 'text-forest' : 'text-muted/60'}`} data-id="element-175" data-mp="14848yxes15rt">
          <Icon className="h-4 w-4" data-id="element-176" data-mp="2foayf35adf8z" />
          {label}
        </span>)}
    </div>;
}